import React from 'react'
import { SVGProps } from 'react'

export const ArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 12h14"
      stroke="url(#a)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m12 5 7 7-7 7"
      stroke="url(#b)"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="a"
        x1={-1.323}
        y1={12.683}
        x2={-0.412}
        y2={17.226}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.258} stopColor="#209F5B" />
        <stop offset={1} stopColor="#209F5B" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={8.839}
        y1={14.567}
        x2={20.265}
        y2={16.603}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.258} stopColor="#209F5B" />
        <stop offset={1} stopColor="#209F5B" />
      </linearGradient>
    </defs>
  </svg>
)
